import getElectron from './getElectron';
export function openWebLink(href, usePopup = false) {
    var _a, _b;
    const electron = getElectron();
    if (electron) {
        electron.send('open-link', href);
    }
    else {
        if (usePopup) {
            const w = 500;
            const h = 650;
            const dualScreenLeft = (_a = window.screenLeft) !== null && _a !== void 0 ? _a : window.screenX; // X of parent
            const dualScreenTop = (_b = window.screenTop) !== null && _b !== void 0 ? _b : window.screenY; // Y of parent
            // 2. How big is the parent window?
            const parentWidth = window.outerWidth;
            const parentHeight = window.outerHeight;
            // 3. Centre the popup inside that rectangle
            const left = dualScreenLeft + (parentWidth - w) / 2;
            const top = dualScreenTop + (parentHeight - h) / 2;
            const features = [
                `width=${w}`,
                `height=${h}`,
                `left=${left}`,
                `top=${top}`,
                'scrollbars=yes',
                'resizable=yes',
                'noopener',
                'noreferrer',
            ];
            window.open(href, 'dbgateCloudLoginPopup', features.join(','));
        }
        else {
            window.open(href, '_blank');
        }
    }
}
